<template>
    <section class="m-buy-house">
        <section class="m-banner">
            <img src="../../assets/images/house/banner_2.jpg" alt="">
        </section>
        <section class="m-floor-1 floor">
            <div class="common-top">
                <span>
                    <i></i>
                    企业介绍
                </span>
                <router-link to="/buyhouse">
                    <img src="../../assets/images/house/more_2.png" alt="">    
                </router-link>
            </div>
            <dl>
                <dt>
                    <div class="video"></div>
                </dt>
                <dd>
                    <ul>
                        <li>
                            <router-link to="/buyhouse">
                                <img src="../../assets/images/house/pic_7.jpg" alt="">
                                <span>万科中心最新楼盘</span>    
                            </router-link>   
                        </li>
                        <li>
                            <router-link to="/buyhouse">
                                <img src="../../assets/images/house/pic_7.jpg" alt="">
                                <span>万科中心最新楼盘</span>    
                            </router-link>   
                        </li>
                    </ul>
                </dd>
            </dl>
        </section>
        <section class="m-floor-2 floor">
            <div class="common-top">
                <span>
                    <i></i>
                    热盘推荐
                </span>
                <router-link to="/buyhouse">
                    <img src="../../assets/images/house/more_2.png" alt="">    
                </router-link>
            </div>
            <ul>
                <li>
                    <router-link to="/buyhouse">
                        <div class="pic">
                            <img src="../../assets/images/house/pic_7.jpg" alt="">
                        </div>
                        <div class="name">恒大地产</div>    
                    </router-link>
                </li>
                <li>
                    <router-link to="/buyhouse">
                        <div class="pic">
                            <img src="../../assets/images/house/pic_7.jpg" alt="">
                        </div>
                        <div class="name">恒大地产</div>    
                    </router-link>
                </li>
                <li>
                    <router-link to="/buyhouse">
                        <div class="pic">
                            <img src="../../assets/images/house/pic_7.jpg" alt="">
                        </div>
                        <div class="name">恒大地产</div>    
                    </router-link>
                </li>
                <li>
                    <router-link to="/buyhouse">
                        <div class="pic">
                            <img src="../../assets/images/house/pic_7.jpg" alt="">
                        </div>
                        <div class="name">恒大地产</div>    
                    </router-link>
                </li>
                <li>
                    <router-link to="/buyhouse">
                        <div class="pic">
                            <img src="../../assets/images/house/pic_7.jpg" alt="">
                        </div>
                        <div class="name">恒大地产</div>    
                    </router-link>
                </li>
                <li>
                    <router-link to="/buyhouse">
                        <div class="pic">
                            <img src="../../assets/images/house/pic_7.jpg" alt="">
                        </div>
                        <div class="name">恒大地产</div>    
                    </router-link>
                </li>
                <li>
                    <router-link to="/buyhouse">
                        <div class="pic">
                            <img src="../../assets/images/house/pic_7.jpg" alt="">
                        </div>
                        <div class="name">恒大地产</div>    
                    </router-link>
                </li>
                <li>
                    <router-link to="/buyhouse">
                        <div class="pic">
                            <img src="../../assets/images/house/pic_7.jpg" alt="">
                        </div>
                        <div class="name">恒大地产</div>    
                    </router-link>
                </li>
                <li>
                    <router-link to="/buyhouse">
                        <div class="pic">
                            <img src="../../assets/images/house/pic_7.jpg" alt="">
                        </div>
                        <div class="name">恒大地产</div>    
                    </router-link>
                </li>
            </ul>
        </section>
        <section class="m-floor-3 floor">
            <div class="common-top">
                <span>
                    <i></i>
                    相关资讯
                </span>
                <router-link to="/buyhouse">
                    <img src="../../assets/images/house/more_2.png" alt="">    
                </router-link>
            </div>
            <dl>
                <dt>
                    <img src="../../assets/images/house/pic_8.jpg" alt="">
                </dt>
                <dd>
                    <router-link to="/buyhouse">每一个人都能真切地感受到40年来生活翻天覆地的变化。</router-link>
                </dd>
            </dl>
            <dl>
                <dt>
                    <img src="../../assets/images/house/pic_8.jpg" alt="">
                </dt>
                <dd>
                    <router-link to="/buyhouse">每一个人都能真切地感受到40年来生活翻天覆地的变化。</router-link>
                </dd>
            </dl>
            <dl>
                <dt>
                    <img src="../../assets/images/house/pic_8.jpg" alt="">
                </dt>
                <dd>
                    <router-link to="/buyhouse">每一个人都能真切地感受到40年来生活翻天覆地的变化。</router-link>
                </dd>
            </dl>
            <dl>
                <dt>
                    <img src="../../assets/images/house/pic_8.jpg" alt="">
                </dt>
                <dd>
                    <router-link to="/buyhouse">每一个人都能真切地感受到40年来生活翻天覆地的变化。</router-link>
                </dd>
            </dl>
        </section>
    </section>
</template>

<script>
    import {swiper , swiperSlide} from 'vue-awesome-swiper'

    export default {
        data(){
            return{
                swiperOption:{
                    slidesPerView: 1.2
                },
                tab: ['热门新盘', '主推户型', 'VR看房'],
                curIndex: 0
            }
        },
        methods:{
            change(index){
                this.curIndex = index;
            }
        }    
    }
</script>

<style lang="less" scoped>
    .common-top{
        display: flex;
        align-items: center;
        margin-bottom: 0.45rem;
        span,a{
            flex: 1;
        }
        span{
            font-size: 0.45rem;
            color: #000;
            font-weight: bold;
        }
        i{
            display: inline-block;
            width: 0.1rem;
            height: 0.4rem;
            background: #ec6244;
            border-radius: 0.2rem;
            vertical-align: middle;
        }
        a{
            text-align: right;
            font-size: 0.35rem;
            color: #adadad;
        }
        img{
            width: 20%;
        }
    }
    .floor{
        padding: 0 0.35rem;
    }
    .m-banner{
        img{
            width: 100%;
        }
    }
    .m-floor-1{
        margin-top: 0.5rem;   
        dl{
            overflow: hidden;
        }
        dt{
            float: left;
            width: 70%;
            padding-bottom: 41%;
            background: #ccc;
            box-sizing: border-box;
            border: 2px solid #fff;
            box-shadow: 0.07rem 0.07rem 0.05rem #c7c7c7;
        }
        dd{
            float: right;
            width: 27%;
            li{
                position: relative;
                box-sizing: border-box;
                border: 2px solid #fff;
                box-shadow: 0.07rem 0.07rem 0.05rem #c7c7c7;
                margin-bottom: 0.2rem;
                &:nth-of-type(2){
                    margin-bottom: 0;
                }
                img{
                    width: 100%;
                }
                span{
                    display: block;
                    bottom: 0;
                    left: 0;
                    padding: 0.1rem 0;
                    background: rgba(0,0,0,0.4);
                    text-align: center;
                    width: 100%;
                    position: absolute;
                    color: #fff;
                    font-size: 0.3rem;
                }
            }
        }
    }
    .m-floor-2{
        margin-top: 0.7rem;
        ul{
            overflow: hidden;
        }
        li{
            width: 31.5%;
            float: left;
            margin: 0 0.25rem 0.25rem 0;
            &:nth-of-type(3n){
                margin-right: 0;
            }
            img{
                width: 100%;
            }
            .pic{
                box-shadow: 0.07rem 0.07rem 0.05rem #c7c7c7; 
            }
            .name{
                font-size: 0.32rem;
                margin-top: 0.1rem;
                text-align: center;
                color: #ed7646;
            }
        }
    }
    .m-floor-3{
        margin-top: 0.7rem;
        padding-bottom: 1.7rem;
        dl{
            overflow: hidden;
            margin-bottom: 0.4rem;
        }
        dt{
            width: 30%;
            float: left;
            img{
                width: 100%;
            }
        }
        dd{
            width: 70%;
            float: right;
            box-sizing: border-box;
            padding-left: 0.3rem;
            a{
                font-size: 0.35rem;
                color: #000;
            }
        }
    }
</style>